import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { QueryParamProvider } from 'use-query-params';
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6';
import {BrowserRouter} from  'react-router-dom'
import { ContextProvider } from './context';
import { Helmet } from 'react-helmet';
//import { parse, stringify } from 'query-string';



const root = ReactDOM.createRoot(document.getElementById('root'));



root.render(
     <React.StrictMode>
      <BrowserRouter>
        <QueryParamProvider adapter={ReactRouter6Adapter} >
          <ContextProvider>         
                <App />            
          </ContextProvider>
        </QueryParamProvider>
      </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
